<template>
    <div :class="{ 'pb-4': (shouldShowClaimButton && !noBottomSpacing), 'pb-2': (!shouldShowClaimButton && !noBottomSpacing), 'pb-3': noBottomSpacing }">
        <loading-screen :is-loading="isClaiming"></loading-screen>

        <!-- Loading -->
        <div v-if="isLoadingIfCanClaimTicket" :class="{'mt-2': !noTopSpacing}">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
        <!-- / Loading -->

        <!-- Claim ticket -->
        <a v-if="shouldShowClaimButton" @click.prevent="attemptClaimTicket" class="btn btn-itg" :class="{'mt-2': !noTopSpacing}" href="#">Office Transfer To
            {{ canClaimTicket.ticket_office_transfer.office.name }} - Click Here To Claim Ticket</a>
        <!-- / Claim ticket -->
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import LoadingScreen from '../../../../../../components/LoadingScreen.vue';

export default {
    props: ['noBottomSpacing', 'noTopSpacing'],

    data() {
        return {
            isClaiming: false
        }
    },

    components: { LoadingScreen },

    methods: {
        ...mapActions('ticketViewer', {
            reloadTicket: 'reloadTicket',
            loadOfficeTransfers: 'loadOfficeTransfers'
        }),

        attemptClaimTicket() {
            swal({
                title: 'Are you sure you want to claim this ticket?',
                // text: 'You are about to claim this ticket. This action cannot be undone.',
                icon: 'info',
                buttons: true
            }).then((willClaim) => {
                if (willClaim) {
                    this.claimTicket();
                }
            });
        },

        claimTicket() {
            let vm = this;
            vm.isClaiming = true;
            axios.post(API_BASE + '/tickets/' + this.canClaimTicket.ticket_office_transfer.ticket_id + '/office-transfers/' + this.canClaimTicket.ticket_office_transfer.id + '/claim')
                .then(function () {
                    vm.isClaiming = false;
                    vm.reloadTicket();
                    vm.loadOfficeTransfers();
                    swal({
                        title: 'Ticket claimed!',
                        text: 'Ticket claimed successfully',
                        icon: 'success',
                        buttons: false,
                        timer: 2000
                    });
                })
                .catch(function (e) {
                    console.log(e);
                    vm.isClaiming = false;
                    swal({
                        title: 'Error',
                        text: 'There was an error claiming this ticket. Please try again.',
                        icon: 'error',
                        buttons: false,
                        timer: 2000
                    });
                });
        }
    },

    computed: {
        ...mapGetters('ticketViewer', {
            isLoadingIfCanClaimTicket: 'isLoadingIfCanClaimTicket',
            canClaimTicket: 'canClaimTicket'
        }),

        shouldShowClaimButton() {
            return (
                !this.isLoadingIfCanClaimTicket &&
                this.canClaimTicket &&
                this.canClaimTicket.claimable &&
                this.canClaimTicket.ticket_office_transfer
            );
        }
    }
}
</script>

<style></style>